<template>
    <div>
        <!-- Header -->
        <div class="py-3 mb-3 border-bottom">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-6 d-flex">
                        <h5 class="m-0 p-0 align-self-center">
                            <i class="fas fa-money-check sb-nav-link-icon"></i> Assinaturas
                        </h5>
                    </div>
                </div>
            </div>
        </div>

        <div class="container">
            
            <div class="row">
                    <div class="mb-3">
                         <b-card title="Minha Assinatura" >
                            <div class="row" v-if="endsAt && isExpired">
                                <div class="col mb-3">

                                    <b-alert variant="primary" show>
                                        Ops, parece que sua assinatura expirou {{ endsAt | moment('from', 'now') }}. Para renovar sua assinatura, acesse nosso portal de cobrança e retome o acesso à nossa plataforma.
                                    </b-alert>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    
                                    <b-card bg-variant="primary" text-variant="white" class="h-100 mb-3">
                                        <p class="h3 font-weight-bold">
                                            {{ productName }}</p>
                                        <p>
                                            Seu plano atual permite o cadastro de até <b>{{ quantityPlan }}</b> alunos.
                                        </p>
                                    </b-card>
                                </div>
    
                                <div class="col">
    
                                    <!-- <b-card class="h-100 mb-3" title="Gerencie sua assinatura" sub-title="Veja suas faturas anteriores, edite seus detalhes de cobrança ou cancele sua assinatura.">
                                    <a class="button" :href='endpointCheckout' style="text-decoration:none">                                
                                        <b-button class="mt-2" variant="outline-primary">Ir para o portal de cobrança</b-button>    
                                    </a>
                                    </b-card> -->

                                    <b-card class="h-100 mb-3" title="Gerencie sua assinatura" sub-title="">
                                        <a class="button" href='/teacher/subscription/plans' style="text-decoration:none">                                
                                            <b-button class="mt-2" variant="outline-primary">Alterar minha assinatura</b-button>    
                                        </a>
                                    </b-card>
                                </div>

                            </div>
                         </b-card>
                    </div>

            </div>
            <div class="row">
                <div class="mb-3">
                    
                    <payment-methods :data="paymentMethods" :defaultPaymentMethod="customer?.invoice_settings.default_payment_method"/>
                </div>
            </div>

            <div class="row">
                <div class="mb-3">
                    <invoices :invoices="invoices" />
                    
                </div>
            </div>
                    
        </div>
        


        

    </div>
</template>

<script>
import PaymentMethods from './PaymentMethods';
import Invoices from './invoices/index.vue'

export default {
    components: {
        PaymentMethods,
        Invoices,
    },
    props: ['endpointCheckout', 'quantityPlan', 'productName', 'endsAt', 'paymentMethods', 'stripeStatus', 'invoices', 'customer'],
    data() {
        return {    
            
        }   
    },
    created() {
    },
    computed: {
        isExpired() {
            return this.endsAt ? this.$moment().isAfter(this.$moment(this.endsAt)) : false
        }
    },
    watch: {
        
    },
    methods: {
       
    }
}
</script>

<style scoped>

</style>
